import StorageIcon from '@mui/icons-material/Storage';
import { Box, Button } from '@mui/material';
import { competitorNames } from '@siren-frontend/shared';

function CompetitorSwitcher({ setMode }) {
  return (
    <Box className="flex-container compare-buttons">
      {Object.entries(competitorNames).map(([compId, compName]) => (
        <Button
          startIcon={<StorageIcon />}
          onClick={() => setMode(compId)}
          className="button competitor-button"
          key={compId}
        >
          {compName}
        </Button>
      ))}
    </Box>
  );
}

export default CompetitorSwitcher;
